import { render, staticRenderFns } from "./GoodsGroups.vue?vue&type=template&id=047febbf&scoped=true"
import script from "./GoodsGroups.vue?vue&type=script&lang=js"
export * from "./GoodsGroups.vue?vue&type=script&lang=js"
import style0 from "./GoodsGroups.vue?vue&type=style&index=0&id=047febbf&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "047febbf",
  null
  
)

export default component.exports